import * as Helper from './helpers.mjs';
import { Form } from './form.mjs';

//TODO: amend to be more like this OR just use the below
// https://github.com/edenspiekermann/a11y-dialog/blob/master/a11y-dialog.js

class Modal{
    constructor(
        modalId
    ) {
        if(!modalId){
            console.error("Modal not specified");
        } else{
            this.modalId = modalId;
            this.modal = document.querySelector("#" + modalId);
        }

        this.action = Helper.getPageInfo("action");
        this.openButtons =  document.querySelectorAll('[data-modal-open=' + modalId + ']');
        this.closeButtons = document.querySelectorAll('[data-modal-close=' + modalId + ']');

        if (this.modal.getAttribute('data-form')) {
            this.submitButtons = this.modal.querySelectorAll('.btn-submit');
            this.formToSubmit = this.modal.getAttribute('data-form');
            this.hasForm = true;
        } else {
            this.hasForm = false;
        }
        this.count = 0;
        this.uid = Helper.getUUID();
        //initiates 
        this.init();
    }

    //?? Are these needed here?
    open(e){
        e.preventDefault();

        let rowIds = this.getSelectedRowIds();

        if(rowIds != null && rowIds.length != 0){
            let rowCount = rowIds.length;
            let counter = this.modal.querySelector('.counter');
            if(counter != null){
                counter.textContent = rowCount;
            
            }
        }

        this.modal.classList.add('active');
        this.modal.removeAttribute('close');
        this.modal.setAttribute('open', true);

        return new Promise(resolve => {
            Helper.PubSub.sub('onClose_' + this.uid, function() {
                resolve();
            });
        });
    }

    close(e){
        e.preventDefault();
        this.modal.classList.remove('active');
        this.modal.removeAttribute('open');
        this.modal.setAttribute('close', true);

        Helper.PubSub.pub('onClose_' + this.uid);
    }

    getSelectedRowIds(){
        let checkboxes = document.querySelectorAll("[id^=selectRow]:checked");
        let rows = [];
        Array.prototype.forEach.call(checkboxes, (checkbox, index) => {
            rows.push(checkbox.parentNode.parentElement.parentNode.dataset.id);
        });
        return rows;
    }

    getModalHeader(){
        let header = this.modal.querySelector('.modal-header');
        let heading = header.querySelector('h3');
        let subheading = header.querySelector('h4');

        return [ heading.innerHTML, subheading.innerHTML];
    }
    
    setModalHeader(heading, subheading){
        //Get contents
        let header = this.modal.querySelector('.modal-header');
        let headingHtml = header.querySelector('h3');
        let subheadingHtml = header.querySelector('h4');
        let closeButton = header.querySelector(".btn");
        // Rebuild contents
        if (heading) {
            headingHtml.innerHTML = heading;
        } else {
            headingHtml.innerHTML = "";
        }
        if (subheading) {
            subheadingHtml.innerHTML = subheading;
        } else {
            subheadingHtml.innerHTML = "";
        }
    }

    getModalBody(){
    
    }
    
    // TODO: Finish this
    setModalBody(contents){
        let body = this.modal.querySelector('.modal-body');
        if (contents) {
            body.innerHTML = "<p>" + contents + "</p>";
        }
    }

    submitForm(e){
        var form = new Form($("#" + this.formToSubmit));
        form.onSubmit(e);

        if(!form.onSubmit(e)){
            this.close(e);
        }
    }


    init(){

        Array.prototype.forEach.call(this.openButtons, (element, index) =>{
            element.addEventListener('click', this.open.bind(this));
        });

        Array.prototype.forEach.call(this.closeButtons,(element, index) =>{    
            element.addEventListener('click', this.close.bind(this));
        });


        var modalCloseButtons = this.modal.querySelectorAll('[aria-label="Close"]');

        if(modalCloseButtons){
            Array.prototype.forEach.call(modalCloseButtons,(button, index) =>{    
                Helper.reattachEventListener(button, 'click', this.close.bind(this));
            });
        }

        if(this.hasForm){

            // Array.prototype.forEach.call(this.submitButtons,(element, index) =>{    
            //     element.addEventListener('click', this.submitForm.bind(this));
            // });
        }

    }
}

export { Modal };